import { useCallback, useEffect, useRef } from 'react';

/**
   Hook to Count time only when the page is visible, the browser tab has focus, and the user
   has interacted with the page within the last 2 minutes.
 */

// stop counting after 2 mins , time definedc(120s ) as stated from the ticket https://app.clickup.com/t/10544926/z93r0b6wu5
export const ENGAGEMENT_WINDOW_MS = 120_000;

// DOM input events to determine the user interaction with webpage
const INPUT_EVENTS = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'scroll', 'touchstart', 'focus'] as const;

const randomTabId = () =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

// unique identifer to current tab so duplicating creates 2 distinct Ids (session storage would duplicate so kept out)
export const TAB_ID = randomTabId();

/**
 * Tab is engaged when page visible (not hidden) page & has focusso even in split view we know
 * this page is focused & the user clicked, typed, or scrolled within the allowed inactivity period (2mins).
 */
export const isTabEngaged = (lastInputAt: number, now = Date.now()) =>
  document.visibilityState === 'visible' && document.hasFocus() && now - lastInputAt < ENGAGEMENT_WINDOW_MS;

export const useTabEngagement = () => {
  // Opening the page is itself an input.
  const lastInputAt = useRef(Date.now());

  useEffect(() => {
    const onInput = () => {
      lastInputAt.current = Date.now();
    };
    // Capture, so scrolls inside inner containers (which don't bubble) are seen too.
    INPUT_EVENTS.forEach(event => window.addEventListener(event, onInput, { capture: true, passive: true }));

    return () => INPUT_EVENTS.forEach(event => window.removeEventListener(event, onInput, { capture: true }));
  }, []);

  return useCallback(() => isTabEngaged(lastInputAt.current), []);
};
